import BdcDashboardSummaryScreen from "../components/Bdc/Dashboard/Summary";

const BdcDashboardPage = () => <BdcDashboardSummaryScreen />;

export default BdcDashboardPage;
